import { appUrl } from 'utils/wrappers';

import ReportsBase from 'app/collections/reports_base';
import PaymentLogReport from 'app/models/payment_log_report';

export default ReportsBase.extend({
  model: PaymentLogReport,
  url: appUrl('reports/payment_log'),
});



// WEBPACK FOOTER //
// ./app/collections/payment_log_reports.js